import { render, staticRenderFns } from "./cpt.vue?vue&type=template&id=6531dcd6&"
import script from "./cpt.vue?vue&type=script&lang=js&"
export * from "./cpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports